export default "__VITE_ASSET__D8XD63D___"